import React from 'react';
import styled from 'styled-components';
import { Link, Flex, Body3Light as Title } from '@/ui';
import { COLORS } from '@/utils/static';
import AttachedIcon from '@/assets/icons/attachment.svg';
import { downloadFileByLink, getFilenameFromUrl } from '@/utils/helpers';
import { usePopups } from '@/hooks';

/**
 * @param file
 * @param title
 * @param url
 * @param props
 * @param isLong
 */
export const AttachedFile = ({ file = null, title = '', url = '', isLong = false, ...props }) => {
  const { showErrorToast } = usePopups();
  let formatTitle = title || getFilenameFromUrl(url);

  const TITLE_MAX_LENGTH = isLong ? 75 : 20;
  const TITLE_SUBSTR_MAX_LENGTH = isLong ? 72 : 17;

  //format long title
  if (formatTitle.length > TITLE_MAX_LENGTH) {
    let titleArray = formatTitle.split('.');

    let extension = titleArray[titleArray.length - 1];

    titleArray.pop();

    let titleString = titleArray.join();

    titleString = titleString.substr(0, TITLE_SUBSTR_MAX_LENGTH);
    titleString += '...';

    formatTitle = titleString + extension;
  }

  const onDownload = async () => {
    try {
      await downloadFileByLink(formatTitle, url);
    } catch (e) {
      showErrorToast(e, true);
    }
  };

  return (
    <Flex align={'center'} {...props}>
      <Icon src={AttachedIcon} />
      <Link onClick={onDownload}>
        <Title color={COLORS.blueAntd}>{formatTitle}</Title>
      </Link>
    </Flex>
  );
};

const Icon = styled.img`
  margin-right: 8px;
  margin-top: -1px;
`;
